export const TIP_VALUE = 50000;
export const COUPON_FIELD = 'couponcode';
export const REWARDS_FIELD = 'rewardfield';
export const COUPON_ERRORS = {
  invalidCouponCode: 'INVALID_COUPON_CODE',
  invalidDispatchMethod: 'COUPON_DISPATCH_METHOD'
};
export const DISCOUNT_ALT_DESCRIPTION = 'Discount icon';
